import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './custom.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from './contexts/Theme.context';
import { BrowserRouter } from 'react-router-dom';
import MyAuth0Provider from './contexts/MyAuth0Provider';
import { CurrentUserProvider } from './contexts/CurrentUser.context';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <MyAuth0Provider>
    <CurrentUserProvider>
      <ThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </CurrentUserProvider>
  </MyAuth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
